import { useStaticQuery, graphql } from 'gatsby'

const fixData = data => ({
  site: data.site,
  menu: data.menu?.menuItems?.nodes,
  secondaryMenu: data.secondaryMenu?.menuItems?.nodes,
 // dropdownMenu: data.dropdownMenu?.menuItems?.nodes,
})

export const useMenuQuery = (id) => {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
      menu: wpMenu(name: { eq: "Main menu" }) {
        menuItems {
          nodes {
            label
            url
            path
            parentId
            id
            childItems {
              nodes {
                label
                url
                path
                id
              }
            }
          }
        }
      }

      secondaryMenu: wpMenu(name: { eq: "Secondary menu" }) {
        menuItems {
          nodes {
            label
            url
            path
            parentId
            id
            childItems {
              nodes {
                label
                url
                path
                id
              }
            }
          }
        }
      }
    }
  `)

if (id === 'dGVybToxMjk5MQ==') {
  const filteredMenu = data.menu?.menuItems?.nodes?.filter((item, index) => index !== 0)
  
  return {
    site: data.site,
    menu: filteredMenu,
    secondaryMenu: data.secondaryMenu?.menuItems?.nodes,
   // dropdownMenu: data.dropdownMenu?.menuItems?.nodes,
  }
}

return fixData(data)
}